module.exports = __webpack_public_path__ + "img/en.8c01945c.png";